import gql from "graphql-tag";
import {LivePaxNodeFragment} from "../../../Queries/LivePax";

export const PAX_QUERY = gql`
query LivePassengers2_GetPax(
    $filter: PassengersFilterInput
    $bookmark: String
    $limit: Int
    $skip: Int
){
    passengers(
        filter: $filter
        bookmark: $bookmark
        limit: $limit
        skip: $skip
    ) {
        bookmark
        docs {
            _id,
            ... on PaxNode {
                ...LivePaxNodeFragment
            }
        }
    }
}
${LivePaxNodeFragment}
`

export const PAX_MUTATION = gql`
    mutation SetPassenger($payload: PaxNodeInput!){
        setPaxNode(
            payload: $payload
        ){
            ...LivePaxNodeFragment
        }
    }
    ${LivePaxNodeFragment}
`